export default __webpack_public_path__ + "static/IMGP1843-177c1a4b788a1a0401ba61c468664852.jpg";